import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CircleButton from './CircleButton';
import ABCyaLib from '@abcya/abcya_lib';

export default class LevelSelect extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.titleLabel = this.scene.add.bitmapText(0, 5, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('select.title_3'), 36).setTintFill('0x980b0d')
      .setOrigin(.5);
    this.add(this.titleLabel);
    this.titleLabel.alpha = 0;

    const { difficultyScale } = ABCyaLib.Environment.instance.gameConfig.select;
    this.optionEasy = new CircleButton(this.scene, this, 'LblEasy', { scale: difficultyScale }).setAlpha(0)
      .setScale(0);
    this.optionEasy.on('pointerup', () => { this.handleButtonClick(this.optionEasy); });

    this.optionMedium = new CircleButton(this.scene, this, 'LblMedium', { scale: difficultyScale }).setAlpha(0)
      .setScale(0);
    this.optionMedium.on('pointerup', () => { this.handleButtonClick(this.optionMedium); });

    this.optionHard = new CircleButton(this.scene, this, 'LblHard', { scale: difficultyScale }).setAlpha(0)
      .setScale(0);
    this.optionHard.on('pointerup', () => { this.handleButtonClick(this.optionHard); });

    const s = 180;
    const centerOffset = 100;
    this.optionEasy.x = centerOffset;
    this.optionMedium.x = 1 * s + centerOffset;
    this.optionHard.x = 2 * s + centerOffset;
    this.optionEasy.y = this.titleLabel.height + 60;
    this.optionMedium.y = this.titleLabel.height + 60;
    this.optionHard.y = this.titleLabel.height + 60;

    this.titleLabel.x = this.getBounds().width / 2 - this.titleLabel.width / 2 + 150;

    this.buttons = [this.optionEasy, this.optionMedium, this.optionHard];
    this.selectedButtonIndex = 1;
    this.buttons[this.selectedButtonIndex].select();
  }

  transitionIn() {
    let tweenwait = 0;
    ABCyaPhaser.Tweens.addTween(this.titleLabel, 220, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.dotPop(this.optionEasy, 420, tweenwait);
    tweenwait += 300;
    this.dotPop(this.optionMedium, 420, tweenwait);
    tweenwait += 300;
    this.dotPop(this.optionHard, 420, tweenwait);
    return tweenwait + 420;
  };

  handleButtonClick(target) {
    const i = this.buttons.indexOf(target);
    if (i !== this.selectedButtonIndex) {
      this.buttons[this.selectedButtonIndex].unselect();
    }
    this.selectedButtonIndex = i;
    this.buttons[this.selectedButtonIndex].select();
  };

  dotPop(obj, time = 320, wait = 0) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scale: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scale: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    });
  };
}